import { smartoltService } from "../../../services/smartolt.service.ts"

export async function queueSmartOltOnuCommand(
  onuExternalId: string,
  operationKey: string,
  extra?: Record<string, unknown>,
) {
  await smartoltService.createCommand(operationKey, {
    path_params: { onu_external_id: onuExternalId },
    ...(extra || {}),
  })
  await smartoltService.runCommandsNow(5)
}

export function unwrapLiveOnu(details: any) {
  return (
    details?.onu_details ||
    details?.response?.onu_details ||
    details?.data?.onu_details ||
    details ||
    {}
  )
}
